import { Card } from '@/components/ui/card'
import { XCircle } from 'lucide-react'
import { EncuestaLayout } from '../../components/public/EncuestaLayout'

export function NoDisponiblePage() {
  return (
    <EncuestaLayout>
      <Card className="p-8 md:p-12 text-center space-y-4">
        <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-red-100">
          <XCircle className="h-8 w-8 text-red-500" />
        </div>
        <h1 className="text-xl font-bold text-gray-800">Encuesta no disponible</h1>
        <p className="text-gray-500 text-sm">
          Esta encuesta no se encuentra disponible en este momento.
          Puede que haya sido desactivada o que el período de respuestas haya finalizado.
        </p>
      </Card>
    </EncuestaLayout>
  )
}
